// import axios from 'axios';
//  import { getToken } from '@/utils/auth'

// const service = axios.create({
//   timeout: 5000,
//   baseURL: process.env.VUE_APP_BASE_URL,

// });

// service.interceptors.request.use(
//   config => {
//     config.withCredentials = true
//     return config;
//   },
//   error => {
//     console.log(error);
//     return Promise.reject();
//   }
// );

// service.interceptors.response.use(
//   response => {
//     debugger
//     if (response.status === 200) {

//       return response.data;
//     } else {
//       Promise.reject();
//     }
//   },
//   error => {
//     console.log(error);
//     return Promise.reject();
//   }
// );

// export default service;

import axios from "axios";
import { Loading, Message } from "element-ui";
import { getToken } from '@/utils/auth'
import store from "../store";

let loading = "";
let flag = 0;
const CancelToken = axios.CancelToken;
const source = CancelToken.source();
axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8'


const service = axios.create({
  // // axios中请求配置有baseURL选项，表示请求URL公共部分
  // baseURL: process.env.VUE_APP_BASE_URL,
  baseURL: process.env.BASE_API,
  timeout: 50000,
  cancelToken: source.token
});

// request拦截器
// service.interceptors.request.use(config => {

service.interceptors.request.use(config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  if (getToken() && !isToken) {
    config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }

  if(config.method==='get'){
    config.params={
      // config.params=config.params||config.data
      _t:Date.parse(new Date()) / 1000,
      ...config.params
    }
  }
  // const token=sessionStorage.getItem('token')
  // if (token) {
  //   config.headers.Authorization = 'Bearer ' + token
  //   }
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})


service.interceptors.response.use(
  function (response) {
  const code = response.data.code || 200;
  if (code === 401) {
     location.href = '/';
    return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
  }else{
    return response;
  }
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js